import { isEmpty } from "lodash";
import React from "react";
import {
  TideItem,
  TideItemForCountry,
  TideItemForDestinations,
  TideItemForGeographicalRegion,
  TideItemForRegion,
} from "../../types";
import { generatePath } from "../../utils";
import Megamenu from "../megamenu";
import { useI18next } from "gatsby-plugin-react-i18next";

interface HotelsMegamenuProps {
  destinations: TideItemForDestinations;
}

const HotelsMegamenu: React.FC<HotelsMegamenuProps> = ({ destinations }) => {
  const geographicalRegions = destinations?.childItems?.filter(
    (tideItem) => tideItem?.templateName === "Geographical region"
  ) as TideItemForGeographicalRegion[];
  const { t } = useI18next();

  const hotelFilter = (tideItem: TideItem | null | undefined) =>
    tideItem?.templateName === "Hotel" ||
    (tideItem?.templateName === "Region" &&
      tideItem?.childItems?.some((y) => y?.templateName == "Hotel"));

  const hotelGroups = geographicalRegions
    .filter(
      (geographicalRegion) =>
        (geographicalRegion.childItems ?? [])
          .flatMap((tideItem) => tideItem?.childItems)
          .filter(hotelFilter).length > 0
    )
    .map((geographicalRegion) => ({
      id: geographicalRegion.id,
      title: !isEmpty(geographicalRegion.content?.general?.title)
        ? (geographicalRegion.content?.general?.title as string)
        : geographicalRegion.name,
      longTitle:
        `${t("FLIGHT_HOLIDAYS")} ` + geographicalRegion.content?.general?.title ??
        geographicalRegion.name,
      items: ((geographicalRegion.childItems as (TideItemForCountry | TideItemForRegion)[]) ?? [])
        .filter((tideItem) => (tideItem?.childItems ?? [])?.filter(hotelFilter).length > 0)
        .map((countryOrRegion) => {
          var url = generatePath(countryOrRegion, generatePath(destinations));

          return {
            id: countryOrRegion?.id ?? undefined,
            url: url ? `${url}#hotels` : undefined,
            imageUrl: countryOrRegion.content?.general?.thumbnailPicture?.url ?? undefined,
            title: countryOrRegion.content?.general?.title ?? undefined,
          };
        }),
    }));

  return <Megamenu groups={hotelGroups} />;
};

export default HotelsMegamenu;
